export enum AuthStatusEnum {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  IDLE = "IDLE",
}
